import { render, staticRenderFns } from "./NudgeButton.vue?vue&type=template&id=4c78e21b&scoped=true&"
import script from "./NudgeButton.vue?vue&type=script&lang=js&"
export * from "./NudgeButton.vue?vue&type=script&lang=js&"
import style0 from "./NudgeButton.vue?vue&type=style&index=0&id=4c78e21b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c78e21b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
